import React, { Component } from 'react';
import styled from 'styled-components';
import { formatByType } from 'helpers/formatNumbers';

const CellWrapper = styled.div``;
const SpanWrapper = styled.span`
    margin-left: 5px;
`;

class CellDivWithLabel extends Component {
    render() {
        const { value, type, strong, labelMeta } = this.props;

        const cellStyle = Object.assign({
            textAlign: typeof value === 'number' ? 'right' : 'left',
            fontWeight: `${strong ? 'bold' : 'normal'}`
        }, this.props.style || {});
        return (
            <CellWrapper style={cellStyle}>
                {type ? formatByType(value, type) : value}
                {labelMeta ? <SpanWrapper className={`label ${labelMeta.color}`} title={labelMeta.hover}>{labelMeta.text}</SpanWrapper> : null}
            </CellWrapper>
        );
    }
}

export default CellDivWithLabel;



// WEBPACK FOOTER //
// ./src/components/molecules/tables/components/CellDivWithLabel.js